import { axiosSwagger } from "@/axios";

function getUserDeliveryUnitId() {
    const userData =
        localStorage.getItem("USER") &&
        JSON.parse(localStorage.getItem("USER"));

    return userData?.deliveryUnit?.id;
}

export const state = {
    simpleFolder: {
        loading: false,
        data: [],
    },
};

export const getters = {};

export const mutations = {
    setSimpleFolderLoading(state, loading) {
        state.simpleFolder.loading = loading;
    },
    setSimpleFolderData(state, data) {
        state.simpleFolder.data = data;
    },
};

export const actions = {
    /**
     * Fetch simple folder list.
     * @param {number} parentId - 0 for root, or the parent folder id
     */
    async readSimpleFolders({ commit }, parentId = 0) {
        const deliveryUnitId = getUserDeliveryUnitId();

        commit("setSimpleFolderLoading", true);

        try {
            const response = await axiosSwagger.get(
                `/api/FileFolder/Simple/My/${parentId}/${deliveryUnitId}`
            );

            commit("setSimpleFolderData", response.data);
            commit("setSimpleFolderLoading", false);

            return response;
        } catch (error) {
            commit("setSimpleFolderLoading", false);
            throw error;
        }
    },
};
